import tokenInterceptor from './token';
import unauthorized from './unauthorized';

const interceptors = {
  install() {
    tokenInterceptor.init();
    unauthorized.init();
  },
};

export default interceptors;
